import { api } from 'app/api'
import { useCallback, useState } from 'react'
import { POST_FOOD_ITEMS_ADD_TO_ALL_SCHOOLS, convertResult, convertParams } from 'app/common/api/requests/food/items/add_to_all_schools/post'
import usePopup from 'app/common/hooks/usePopup'


type Options = {
  dishIds: Array<string>
  onSubmitSuccess?: () => void,
}
export const useDishesAddToAllOrgs = ({ dishIds, onSubmitSuccess }: Options) => {
  const [pending, setPending] = useState<boolean>(false)
  const popup = usePopup()


  const submit = useCallback(async () => {
    if (!dishIds || dishIds.length === 0) return
    setPending(true)

    const res = await api.request(POST_FOOD_ITEMS_ADD_TO_ALL_SCHOOLS, {
      error: 'Не удалось добавить выбранную продукцию ко всем школам',
      params: {
        dishIds,
      },
      convertions: {
        convertParams,
        convertResult
      },
    })
    if (res) {
      setPending(false)
      popup('Выбранная продукция успешно добавлена ко всем школам')
      onSubmitSuccess && onSubmitSuccess()
      return true
    }
    setPending(false)
    return false
  }, [dishIds, popup, onSubmitSuccess])


  return {
    pending,
    submit,
  }
}
